import React from 'react'
import {Name, LogoTwo, LogoThree, Header, BreedInfo} from './styles'

const HeaderComponent = ({textColor}) => (
  <Header>
    <Name textColor={textColor}>Dobby</Name>
    <BreedInfo>
      <LogoTwo textColor={textColor}>mini</LogoTwo>
      <LogoThree textColor={textColor}>chinuinie</LogoThree>
    </BreedInfo>
  </Header>
)

export default HeaderComponent
